import { GetListRequestParams } from "libs/api";

/* eslint-disable react-hooks/exhaustive-deps */
import { useProductBadges } from "../apis";

const useProductBadgesSelectorList = () => {
  const requestParams: GetListRequestParams = {
    page: 1,
    take: 50
  };

  const { badges, isLoading } = useProductBadges(requestParams);

  return {
    badges,
    isLoading
  };
};

export default useProductBadgesSelectorList;
